module.exports = __webpack_public_path__ + "static/media/class_job_018.217e193a.svg";